import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import api from "@/lib/axios"
import { AxiosError } from "axios"
import { Loader2 } from "lucide-react"
import toast from "react-hot-toast"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"

const postDataSync = async (id_sys_periode: string) => {
  const response = await api.post("/setting/sys-prodi/sync-daya-tampung", {
    id_sys_periode,
  })
  return response.data
}

export default function FormDayaTampung({
  closeModal,
}: {
  closeModal: () => void
}) {
  const [searchParams] = useSearchParams()
  const idSysPeriodeParams = searchParams.get("id") || ""

  const queryClient = useQueryClient()

  const { mutate, isPending } = useMutation({
    mutationFn: () => postDataSync(idSysPeriodeParams),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["periode"] })
      queryClient.invalidateQueries({ queryKey: ["listSysJurusanSekolah"] })
      closeModal()
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleSync = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    mutate()
  }

  return (
    <form onSubmit={handleSync}>
      <FormHeader
        title="Sinkronisasi Daya Tampung"
        icon={<></>}
        description="Apakah anda yakin akan melakukan sinkronisasi daya tampung?"
      />
      <div className="mt-3 flex gap-3">
        <Button
          type="button"
          variant={"outline"}
          onClick={closeModal}
          disabled={isPending}
        >
          Batal
        </Button>
        <Button className="flex items-center gap-3" disabled={isPending}>
          {isPending ? (
            <>
              <Loader2 className="w-4 h-4 mr-1 animate-spin" />
              Processing...
            </>
          ) : (
            "Sinkron"
          )}
        </Button>
      </div>
    </form>
  )
}
